module.exports = __webpack_public_path__ + "static/img/1_10commitments_100milliontonnes.f8c2f7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/1_10commitments_100milliontonnes.jpg
// module id = anRr
// module chunks = 0